export const autoAnalysedResilienceTypeValues = ["low_resilience", "modern_resilience", "enhanced_resilience"] as const;
export const autoAdaptationTypeValues = ["baseline", ...autoAnalysedResilienceTypeValues] as const;
export const adaptationTypeValues = [...autoAdaptationTypeValues, "custom"] as const;
export type AdaptationType = (typeof adaptationTypeValues)[number];
export type AggregateLevelAdaptationTypes = Extract<AdaptationType, "baseline" | "enhanced_resilience">;

export type AdaptationTerms = AdaptationType | "automatedResilience" | "absoluteChange" | "relativeChange";

export const DELTA_COLOR = "#EA580C";
export const ADAPTATION_TERM_COLORS: Record<AdaptationTerms, string> = {
  automatedResilience: "#1F2937",
  baseline: "#1F2937",
  low_resilience: "#e879f9",
  modern_resilience: "#38bdf8",
  enhanced_resilience: "#14b8a6",
  custom: "#DB2777",
  absoluteChange: DELTA_COLOR,
  relativeChange: DELTA_COLOR,
};

export type TermDisplayConfig = { contextId: string; color: string; description: string };
// remove Partial type after custom type is introduced
export const adaptationConfig: Record<AdaptationType, TermDisplayConfig> = {
  baseline: {
    contextId: "baselineAdaptation",
    color: ADAPTATION_TERM_COLORS["baseline"],
    description:
      "Represents the baseline risk outcome using the asset input settings originally provided at the time of upload.",
  },
  low_resilience: {
    contextId: "lowResAdaptation",
    color: ADAPTATION_TERM_COLORS["low_resilience"],
    description:
      "A lower resilience outcome for an older asset built to lower performance standards.  Represents a plausible upper-bound risk outcome for the asset when asset characteristics are uncertain. Settings are automatically applied by the system",
  },
  modern_resilience: {
    contextId: "modernResAdaptation",
    color: ADAPTATION_TERM_COLORS["modern_resilience"],
    description:
      "A standard resilience outcome for a modern asset built to common, present-day performance standards. Represents a plausible lower-bound risk outcome for the asset when asset characteristics are uncertain. Settings are automatically applied by the system",
  },
  enhanced_resilience: {
    contextId: "autoEnhancedResilience",
    color: ADAPTATION_TERM_COLORS["enhanced_resilience"],
    description:
      "Enhanced Resilience outcome for a proactively adapted asset.  Represents a reasonably achievable adaptation scenario that extends beyond common, present-day building standards. Settings are automatically applied by the system",
  },
  custom: {
    contextId: "",
    color: ADAPTATION_TERM_COLORS["custom"],
    description: "",
  },
};

// TODO: pull directly from terms (translations) here as title
export const termsConfig: Record<Exclude<AdaptationTerms, AdaptationType>, TermDisplayConfig> = {
  absoluteChange: {
    contextId: "absoluteChange",
    description: "",
    color: ADAPTATION_TERM_COLORS["absoluteChange"],
  },
  relativeChange: {
    contextId: "relativeChange",
    description: "",
    color: ADAPTATION_TERM_COLORS["relativeChange"],
  },
  automatedResilience: {
    contextId: "automatedResilience",
    description: "",
    color: ADAPTATION_TERM_COLORS["automatedResilience"],
  },
};

export const adaptationTermsConfig = { ...adaptationConfig, ...termsConfig };
